module.exports = require("hemera-joi");